import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import { Button, Box } from "@mui/material";
import { LoginForm } from "../utils/loginFunc";
import { useNavigate } from "react-router-dom";
import { loggedIn } from "../store/gloabalState";
import { useRecoilState } from "recoil";
import useNotify from "../utils/useNotify";
import Cookies from "js-cookie";

export default function Login() {
  const [isLoggedIn, setIsLoggedIn] = useRecoilState(loggedIn);
  const [loginForm, setLoginForm] = useState({
    email: "",
    password: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const [loginError, setLoginError] = useState();
  const navigate = useNavigate();

  const redirectFunc = () => {
    setIsLoggedIn(true);
    notify.success("Logged in successfully!");
    window.location.href = "/";
  };

  const getLoginErrors = (e) => {
    setLoginError(e);

    if (e.code === "ERR_BAD_REQUEST")
      notify.error("Username or Password mismatch Please Check!");
  };
  const loginFormFunc = (e) => {
    e.preventDefault();
    setFormErrors(validate(loginForm));
    if (loginForm.email) {
      LoginForm(loginForm, redirectFunc, getLoginErrors);
    }
  };
  const validate = (values) => {
    const err = {};
    const regex = /^[\w+]+([\.\-\+]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (!values.email) {
      err.email = "Email required";
    } else if (!regex.test(values.email)) {
      err.email = "Email not valid";
    }

    if (!values.password) {
      err.password = "Password required";
    }

    return err;
  };
  let notify = useNotify();

  useEffect(() => {
    function checkAndRedirect() {
      if (isLoggedIn) {
        navigate("/");
        return false;
      }
    }
    checkAndRedirect();
  }, []);

  return (
    <Box className="loginform">
      <Box
        component="form"
        sx={{
          "& > :not(style)": { m: 1, width: "25ch" },
        }}
        noValidate
        autoComplete="off"
      >
        <TextField
          label="User Name"
          type={"email"}
          required
          variant="outlined"
          placeholder="user@gmail.com"
          sx={{ width: "200px" }}
          onChange={(e) =>
            setLoginForm({ ...loginForm, ["email"]: e.target.value })
          }
        />
        <p className="error">{formErrors.email}</p>
        <TextField
          label="Password"
          required
          type={"password"}
          variant="outlined"
          placeholder="******"
          sx={{ width: "200px" }}
          onChange={(e) =>
            setLoginForm({ ...loginForm, ["password"]: e.target.value })
          }
        />
        <p className="error">{formErrors.password}</p>
        <Button variant="contained" onClick={loginFormFunc}>
          Submit
        </Button>
      </Box>
    </Box>
  );
}
